export default __webpack_public_path__ + "static/media/people2.8702bb51.jpg";